const MEMBER_VIEW_PAGE_PATH = '/member-view/accounts';
export const MEMBER_VIEW_PAGE_COOKIE = '__Secure-member-view-page';
export const MEMBER_VIEW_NAV_COOKIE = '__Host-member-view-nav';
export const MEMBER_VIEW_NONCE_STORAGE_KEY = 'member-view-request-nonce';

export function isMemberViewPage(path: string) {
  return (
    path === MEMBER_VIEW_PAGE_PATH ||
    path.startsWith(`${MEMBER_VIEW_PAGE_PATH}/`)
  );
}

const supportedPages = new Set([
  '/member-view/accounts/portfolio/properties',
  '/member-view/accounts/portfolio/listing-performance',
  '/member-view/accounts/profile',
]);

export function isSupportedMemberViewPage(path: string) {
  return supportedPages.has(path.endsWith('/') ? path.slice(0, -1) : path);
}

export function isBrowserMemberViewPage() {
  return (
    typeof window !== 'undefined' && isMemberViewPage(window.location.pathname)
  );
}

export function memberViewPageUrl(accountPath: string) {
  if (accountPath !== '/accounts' && !accountPath.startsWith('/accounts/'))
    return null;
  return `/member-view${accountPath}`;
}
